import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-953eb524.js';
import './chunk-9c9b9c25.js';
import './chunk-87d126e7.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-4422ad31.js';
import './chunk-360e7443.js';
import './chunk-42f463e6.js';
import './chunk-9197dc16.js';
import './chunk-63dd07b4.js';
import './chunk-2c6bf841.js';
import { D as Datepicker } from './chunk-e9cfd07f.js';
export { D as BDatepicker } from './chunk-e9cfd07f.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;
